export default function imageLoader(imageUrls: string[]): Promise<any> {
	function loader(imgSrc: string): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			let img: HTMLImageElement = new Image();
			img.onload = () => resolve(imgSrc);
			img.onerror = (err: ErrorEvent) => reject(`Failed to load ${imgSrc}`);
			img.src = imgSrc;
		});
	}

	let loaders: Promise<any>[] = [];
	for (const image of imageUrls) {
		loaders.push(loader(image));
	}

	return Promise.all(loaders);
}
